/**
 * Substring matching, deliberately. At eight nav items a fuzzy matcher gives
 * less predictable ordering than `includes` and is a dependency we would carry
 * forever — see BRI-1502.
 */
export const filterNavItems = <T extends { label: string }>(items: T[], query: string): T[] => {
  const needle = query.trim().toLowerCase()

  if (!needle) {
    return items
  }

  return items.filter((item) => item.label.toLowerCase().includes(needle))
}

/** Moves the highlight down one row, wrapping back to the top. */
export const getNextIndex = (current: number, length: number): number =>
  length === 0 ? 0 : (current + 1) % length

/** Moves the highlight up one row, wrapping round to the bottom. */
export const getPreviousIndex = (current: number, length: number): number =>
  length === 0 ? 0 : (current - 1 + length) % length

/**
 * `Ctrl+K` is Chrome's omnibox shortcut and `Cmd+K` is claimed elsewhere, so the
 * caller must `preventDefault()` on a match or the browser wins.
 */
export const isPaletteShortcut = (event: KeyboardEvent): boolean =>
  (event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'k'
